import {
  PageHeaderBackButton,
  type PageHeaderBackButtonProps,
} from './pageHeaderBackButton';
import {
  PageHeaderGankster,
  type PageHeaderGanksterProps,
} from './pageHeaderGankster';
import {
  PageHeaderNonToxicBadge,
  type PageHeaderNonToxicBadgeProps,
} from './pageHeaderNonToxicBadge';
import { PageHeaderPlayNowToggle } from './pageHeaderPlayNowToggle';
import { PageHeaderRoot, type PageHeaderRootProps } from './pageHeaderRoot';
import { PageHeaderTitle, type PageHeaderTitleProps } from './pageHeaderTitle';

export const PageHeader = {
  Root: PageHeaderRoot,
  BackButton: PageHeaderBackButton,
  Title: PageHeaderTitle,
  NonToxicBadge: PageHeaderNonToxicBadge,
  Gankster: PageHeaderGankster,
  PlayNowToggle: PageHeaderPlayNowToggle,
} as const;

export type {
  PageHeaderBackButtonProps,
  PageHeaderGanksterProps,
  PageHeaderNonToxicBadgeProps,
  PageHeaderRootProps,
  PageHeaderTitleProps,
};
